import { Modules, MTD } from '@app/core/Enum';
import {
  ChartOfAccountListParam,
  FileUploadRequestModel,
  GenerateSaasURLModel,
  GlobalStandardPermission,
  MainListParameters,
  MultipleFileDownloadModel,
  QueryParams,
  UserStandardPermission,
  ViewParamModel,
} from '@app/core/Models';
import { Guid } from 'guid-typescript';

export class CheckEntryNumber {
  static readonly type = '[IMPORT] Check Entry Number';

  constructor(public entryNumber: string, public moduleId: number) {}
}

export class CheckCustomerSupplierDuplicate {
  static readonly type = '[IMPORT] Check Customer Supplier Duplicate';

  constructor(
    public name: string,
    public email: string,
    public moduleId: number
  ) {}
}

export class GetSideList {
  static readonly type = '[SIDELIST] Get Side-List  List ';

  constructor(public queryParams: QueryParams, public moduleId: Modules) {}
}

export class GetMainList {
  static readonly type = '[MAINLIST] Get Main-List List ';

  constructor(
    public queryParams: MainListParameters,
    public moduleId: Modules
  ) {}
}

export class GetNominalLedgerReport {
  static readonly type = '[NOMINALLEDGER] Get Nominal Ledger Report ';

  constructor(public queryParams: MainListParameters) {}
}

export class GetVatReportDetailList {
  static readonly type = '[REPORTLIST] Get Vat Report Detail List ';

  constructor(public vatId: number, public queryParams: any) {}
}

export class GetNominalLedgerTransaction {
  static readonly type =
    '[NOMINALLEDGERTRANSACTION] Get Nominal Ledger Transaction ';

  constructor(public queryParams: any) {}
}

export class GetVatReportList {
  static readonly type = '[REPORTLIST] Get Vat Report List ';

  constructor(public queryParams: any) {}
}

export class GetReportList {
  static readonly type = '[REPORTLIST] Get Report-List List ';

  constructor(
    public queryParams: MainListParameters,
    public moduleId: Modules
  ) {}
}

export class GetAccountTransactionList {
  static readonly type =
    '[ACCOUNTTRANSACTIONLIST] Get Account transaction List ';

  constructor(
    public queryParams: MainListParameters,
    public id: Guid,
    public moduleId: number
  ) {}
}

export class GetTransactionLogData {
  static readonly type = '[ACCOUNTTRANSACTIONLIST] Get Transaction Log Data ';

  constructor(public id: Guid) {}
}

export class GetBankAccountTransactionData {
  static readonly type =
    '[ACCOUNTTRANSACTIONLIST] Get Bank Account Transaction Data ';

  constructor(public id: Guid) {}
}

export class GetHeaderList {
  static readonly type = '[HEADERLIST] Get Header List ';

  constructor(public moduleId: Modules) {}
}

export class Export {
  static readonly type = '[EXPORT] Export ';

  constructor(
    public queryParams: MainListParameters,
    public moduleId: Modules
  ) {}
}

export class ReportExport {
  static readonly type = '[EXPORT] Report Export ';

  constructor(public queryParams: MainListParameters, public id: Guid) {}
}

export class GiftAidDonationDetailListExport {
  static readonly type = '[EXPORT] Gift Aid Donation Detail List Export ';

  constructor(public queryParams: MainListParameters, public id: Guid) {}
}

export class ExportReceipt {
  static readonly type = '[EXPORTRECEIPT] Export Receipt';

  constructor(
    public moduleId: Modules,
    public ids: Array<Guid>,
    public isPrint: boolean
  ) {}
}

export class EditReceipt {
  static readonly type = '[EditReceipt] Edit Receipt';

  constructor(public ids: Array<Guid>, public moduleId: Modules) {}
}

export class ReportDetailView {
  static readonly type = '[REPORTDETAILVIEW] Detail View';

  constructor(public id: Guid, public moduleId: number) {}
}

export class FileUpload {
  static readonly type = '[FILE] File Upload';

  constructor(public fileUploadRequestModel: FileUploadRequestModel) {}
}

export class GetCurrencyList {
  static readonly type = '[CURRENCY] Get Currency';
}

export class Copy {
  static readonly type = '[COPY] Copy';

  constructor(public moduleId: number, public ids: Array<Guid>) {}
}

export class CustomEmail {
  static readonly type = '[CUSTOMEMAIL] Custom Email';

  constructor(public moduleId: number, public emailData: any) {}
}

export class FileDownload {
  static readonly type = '[FILE] File Download';

  constructor(public fileData: MultipleFileDownloadModel) {}
}

//#region transactions
export class GetVatRateList {
  static readonly type = '[VATRATE] Get Vat Rate List';
}

export class GetProductData {
  static readonly type = '[PRODUCT] Get Product Data By Product Id';

  constructor(public productId: Guid) {}
}
export class GetProductUnit {
  static readonly type = '[PRODUCT] Get Product Unit';
}

export class GetChartOfAccountsBasedOnGroupId {
  static readonly type = '[CHARTOFACCOUNT] Get Invoice Type';

  constructor(public groupIds: Array<number>) {}
}

export class GetChartOfAccountsBasedOnGroupIdAndTypeId {
  static readonly type =
    '[ChartOFACCOUNT] Get Accounts Based On GroupId And TypeId';

  constructor(public param: ChartOfAccountListParam) {}
}

export class GetDefaultCurrency {
  static readonly type = '[CURRENCY] Get Default Currency';
}

export class GetModuleDetailView {
  static readonly type = '[INVOICEVIEW] Get Invoice View';

  constructor(public param: ViewParamModel) {}
}

export class GetStandardAccountList {
  static readonly type = '[ACCOUNT] Get Standard Account List';

  constructor(public entityId: Array<number>) {}
}

export class GetNonStandardAccountList {
  static readonly type = '[ACCOUNT] Get Non Standard Account List';

  constructor(public entityId: Array<number>) {}
}

export class GetGroupNonStandardAccountList {
  static readonly type = '[ACCOUNT] Get Group Non Standard Account List';

  constructor(public entityId: Array<number>) {}
}

//#endregion
export class GetFinancialPeriod {
  static readonly type = '[COMMON] Get Periodic Year';
}

export class LockFinancialPeriod {
  static readonly type = '[COMMON] Lock Periodic Year';

  constructor(public financialData: any) {}
}

export class GetCustomBankAccountList {
  static readonly type = '[ACCOUNT] Get Custom Bank Account List';
}

export class GetCashAccountList {
  static readonly type = '[ACCOUNT] Get Cash Account List';
}

export class GetGroupList {
  static readonly type = '[ACCOUNT] Get Group All List';
}

export class GetGroupAccountsBasedOnGroupId {
  static readonly type = '[ACCOUNT] Get Group Accounts Based on GroupId';

  constructor(public groupIds: Array<number>) {}
}

export class GetAccountsBasedOnGroupId {
  static readonly type = '[ACCOUNT] Get Accounts Based on GroupId';

  constructor(public groupIds: Array<number>) {}
}

export class GetAccountsBasedOnGroupIdAndTypeId {
  static readonly type = '[ACCOUNT] Get Accounts Based On GroupId And TypeId';
  constructor(public param: ChartOfAccountListParam) {}
}

export class GetGroupAccountsBasedOnGroupIdAndTypeId {
  static readonly type =
    '[ACCOUNT] Get Group Accounts Based On GroupId And TypeId';

  constructor(public param: ChartOfAccountListParam) {}
}

export class GetGroupAccountList {
  static readonly type = '[ACCOUNT] Get Group Account List';

  constructor(public entityId: Array<number>) {}
}

export class GetCustomBankAndCashAccount {
  static readonly type = '[ACCOUNT] Get Custom Bank And Cash Account List';

  constructor(public fundId ?: any) {}
}

export class GetCreditorDebtorReport {
  static readonly type = '[REPORT] Get Creditor Debtor Report ';

  constructor(
    public queryParams: MainListParameters,
    public moduleId: number
  ) {}
}

export class GetCreditorDebtorTransaction {
  static readonly type = '[REPORT] Get Creditor Debtor Transaction ';

  constructor(
    public queryParams: any,
    public moduleId: number,
    public id: any
  ) {}
}

export class GetVatViewData {
  static readonly type = '[DETAILLIST] Get Vat View Data ';

  constructor(
    public queryParams: MainListParameters,
    public detailListId: any
  ) {}
}

export class GetDetailList {
  static readonly type = '[DETAILLIST] Get Deatil-List List ';

  constructor(public queryParams: MainListParameters, public dataParam: any) {}
}

export class ExportMTD {
  static readonly type = '[EXPORT] Export MTD';

  constructor(
    public queryParams: MainListParameters,
    public moduleId: Modules
  ) {}
}

export class GetDetailHeaderList {
  static readonly type = '[DETAILHEADERLIST] Get Detail Header List ';

  constructor(public mtdId: MTD) {}
}

export class GetReportDetailList {
  static readonly type = '[REPORTDETAILLIST] Get Report Deatil-List List ';

  constructor(public queryParams: MainListParameters) {}
}

export class GetReportDetailHeaderList {
  static readonly type =
    '[REPORTDETAILHEADERLIST] Get Report Detail Header List ';
}

export class UpdateThemeColor {
  static readonly type = '[COLOR] Update Theme Color';

  constructor(public colorCode: string) {}
}

export class SendEmail {
  static readonly type = '[SENDEMAIL] Send Email';

  constructor(public moduleId: Modules, public id: Guid) {}
}

export class GetGroupCustomBankAndCashAccount {
  static readonly type =
    '[BANKTRANSFER] Get Group Custom Bank And Cash Account';
}

export class DeleteBankImportTransactionHistory {
  static readonly type =
    '[BANKTRANSFER] Delete Bank Import Transaction History';

  constructor(public ids: Array<Guid>) {}
}

export class GetFontFamilies {
  static readonly type = '[FONTFAMILIES] Get Font Families';
}

export class GetSaasURL {
  static readonly type = '[GENRATESASURL] Get Saas Url';
  constructor(public genrateurl: GenerateSaasURLModel) {}
}

export class CheckDonorDuplicate {
  static readonly type = '[IMPORT] Check Donor Duplicate';

  constructor(
    public name: string,
    public lastName: string,
    public email: string
  ) {}
}

export class GetAdvancePaymentList {
  static readonly type = '[ADVANCEPAYMENT Get Non Standard Account List';

  constructor(public entityId: Guid) {}
}

export class GetAllocationData {
  static readonly type = '[COMMON] Get Allocation Data';

  constructor(public id: Guid, public moduleId: number) {}
}

export class SaveAllocation {
  static readonly type = '[COMMON] Save Allocation';

  constructor(public allocationData: any, public moduleId: number) {}
}

export class GetTitleList {
  static readonly type = '[COMMON] Get Titles';
}

export class GetUserBusinessPermission {
  static readonly type = '[COMMON] Get User Business Permission';
  constructor(public userId: Guid, public roleId: number) {}
}

export class GetPermissions {
  static readonly type = '[COMMON] Get Permissions';
  constructor(public searchText?: string) {}
}

export class SaveBusinessPermission {
  static readonly type = '[COMMON] Save Business Permission';
  constructor(
    public standardPermission: GlobalStandardPermission[],
    public userId: Guid
  ) {}
}

export class SaveUserPermission {
  static readonly type = '[COMMON] Save User Permission';
  constructor(
    public standardPermission: UserStandardPermission[],
    public userId: Guid,
    public roleId: number
  ) {}
}

export class GetFileAsByte {
  static readonly type = '[Common] Get File As Byte';

  constructor(public fileUrl: string) {}
}

export class GetIsVatRegistered {
  static readonly type = '[Common] Get Is Vat Registered';
}

export class ShareFile {
  static readonly type = '[Common] Share file';

  constructor(
    public moduleId: Modules,
    public attachmentParams: MainListParameters,
    public toMailId: string,
    public ccMailId: string,
    public bccMailId: string,
    public message: string,
    public subject: string
  ) {}
}

export class GetCompanyVatSchemaId {
  static readonly type = '[COMPANY] Get Company Vat Schema Id';
  constructor() {}
}
export class GetAllDislcosuresListBasedonType {
  static readonly type = '[AuditReport] Get All Dislcosures List Based on Type';

  constructor(public type: any,public isAudicted:boolean) {}
}
export class ToggleCheck {
  static readonly type = '[AuditReport] Toggle Check';

  constructor(public AuditReportDetails: any) {}
}

export class GetUnExplainedBankTransactions {
  static readonly type = '[COMMON] Get UnExplained Bank Transactions ';

  constructor(public postingAccountId: any) {}
}

export class SaveReconciliation {
  static readonly type = '[COMMON] Save Reconciliation';

  constructor(public reconcilationData: any) {}
}  
export class DeleteAccountingPeriod {
  static readonly type = '[FINANCIALYEAR] Delete Accounting Period';

  constructor(public ids: Array<Guid>) {}
}

export class GetTrusteesDisclosuresBasedOnPeriodId {
  static readonly type = '[AuditReport] Get All Trustees List Based on PeriodID';

  constructor(public periodId: any,public isAudicted:boolean) {}
}

export class ToggleCheckTrustee {
  static readonly type = '[AuditReport] Toggle Check for Trustee';

  constructor(public AuditReportDetails: any) {}
}

export class GetFundIdBasedonAccountIdAsync {
  static readonly type = '[COMMON] Get Fund Id Based on Account Id Async';
  constructor(public accountId: string) {}
}